const ParticularId = "662b9fe7d6ae02796c2f144f";
const SusId = "65e86be661640f7be5450cb4";
const UnimedId = "65d361a561640f7be544f46a";

export {
    ParticularId,
    SusId,
    UnimedId
};